import React from 'react'
import { fmtDelta } from '@/utils/format'

export default function Delta({ value }: { value: number | null | undefined }) {
  const d = fmtDelta(value)
  if (!d) return null
  return <span className={`delta ${d.cls}`}>{d.text}</span>
}
